module.exports = __webpack_public_path__ + "static/supermarkt-1f547816214499e4137db32981d1d0a0.PNG";